export default __webpack_public_path__ + "static/media/docx.34bc07f7.svg";